<template>
  <div class="master-container">
    <v-content>
      <v-card flat class="mx-3 mt-2 pa-2">
        <v-card-title>イベント新規登録</v-card-title>
        <v-list-item-subtitle><strong class="red--text text--lighten-1">*</strong>：必須項目</v-list-item-subtitle>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-select
            v-model="formData.kki_cd"
            :rules="mustRules"
            :items="kkiList"
            @change="selectkki($event)"
            label="機械名*"
            item-value="kki_cd"
            item-text="kki_nm"
            required
            return-object
          >
            <template v-slot:label>
              機械名<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-select>
          <v-text-field
            v-model="formData.evnt_cd"
            :rules="cdRules"
            label="イベントコード*"
            placeholder='半角英数字、!@$#_.のみ使用可'
            required
          >
            <template v-slot:label>
              イベントコード<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.evnt_nm"
            :rules="mainRules"
            label="イベント名*"
            required
          >
            <template v-slot:label>
              イベント名<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-select
            v-model="formData.bnri_typ"
            :items="bnri_typList"
            @change="selectbnri($event)"
            label="分類"
            item-value="no"
            item-text="name"
            clearable
            return-object
          ></v-select>
          <v-select
            v-model="formData.event_typ"
            :items="evnt_typList"
            @change="selectevnt($event)"
            label="イベント区分"
            item-value="no"
            item-text="name"
            clearable
            return-object
          ></v-select>
          <v-btn width="120" color="indigo lighten-5" depressed to='/EvntMstr/EvntMstrKnr'>キャンセル</v-btn>
          <div class="float-right">
            <!-- 保存された情報をダイアログに表示 -->
            <v-dialog v-model="checkDialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark color="indigo" width="120" v-bind="attrs" v-on="on" @click="validate">
                  登録
                </v-btn>
              </template>
              <v-card v-if="errorFlg">
                <v-card-title class="headline indigo lighten-4" primary-title>新規登録確認</v-card-title>
                <v-container v-if='loading'>
                  <v-row justify="center" align-content="center">
                    <v-col cols="6">
                      <v-progress-linear
                        color="indigo"
                        indeterminate
                        rounded
                        height="6"
                      ></v-progress-linear>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-text v-else>
                  <v-container>
                    <span style="white-space:pre-wrap;">{{errorMsg}}</span>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" text @click="checkDialog = false">OK</v-btn>
                </v-card-actions>
              </v-card>
              <v-card v-else>
                <v-card-title class="headline indigo lighten-4" primary-title>新規登録確認</v-card-title>
                <v-container v-if='loading'>
                  <v-row justify="center" align-content="center">
                    <v-col cols="6">
                      <v-progress-linear
                        color="indigo"
                        indeterminate
                        rounded
                        height="6"
                      ></v-progress-linear>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-text v-else>
                  <v-container>
                    <v-row>
                      以下の内容で登録します。よろしいですか？<br>
                    </v-row>
                    <!-- 登録内容 -->
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">機械名</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{kkiSelectList.kki_nm}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">イベントコード</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.evnt_cd}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">イベント名</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.evnt_nm}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">分類</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{bnri_typSelectList.name}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">イベント区分</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{event_typSelectList.name}}
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" text @click="checkDialog = false">キャンセル</v-btn>
                  <v-btn dark color="indigo" width="120" @click="submit()">登録</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- 確認ポップ end -->
          </div>
        </v-form>
      </v-card>
    </v-content>
  </div>
</template>

<script>
import MstrHedr from '../../modules/MstrHedr'
import MsgList from '../../modules/MsgList'
import myAxios from '../../../axios/myAxios'

export default {
  components: {
    MstrHedr
  },
  props: {
    formData: Object
  },
  data () {
    return {
      mainRules: [
        v => !!v || '入力は必須です',
        v => (v || '').search(' ') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v || '').search('　') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v.length <= 100) || '100文字以内で入力してください'
      ],
      cdRules: [
        v => !!v || '入力は必須です',
        v => (v || '').match(/^[A-Za-z0-9!@$#_.]*$/) || '半角英数字および!@#$_.で入力してください',
        v => (v || '').indexOf(' ') < 0 || '空文字が含まれています',
        v => (v || '').indexOf('　') < 0 || '空文字が含まれています',
        v => (v.length <= 10) || '10文字以内で入力してください'
      ],
      mustRules: [
        v => !!v || '入力は必須です'
      ],
      checkDialog: false,
      loading: true,
      valid: true,
      evntDupCdIsValid: true,
      evntNameIsValid: true,
      evntCdIsValid: true,
      kkiCdIsValid: true,
      blankIsValid: true,
      userInfo: false,
      isChange: false,
      bnri_typList: [],
      bnri_typSelectList: {},
      evnt_typList: [],
      event_typSelectList: {},
      event_list: [],
      kkiList: [],
      kkiSelectList: { kki_cd: '', kki_nm: '' },
      MSG_COM_0001: MsgList.MSG_COM_0001,
      errorMissMsg: '入力内容に間違いがあります。',
      errorFlg: false,
      errorMsg: '',
      errorCdMsg: '',
      select_kki_cd: '',
      select_bnri_typ: '',
      select_evnt_typ: ''
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isChange) {
      const dialog = window.confirm(MsgList.MSG_CREATE_FORM_LEAVE)
      if (dialog) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  created () {
    // ログインセッションを確認する
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result
      myAxios.get('/api/common/session_manager', {type: 'kngn_check', url: this.$route.path}).then(res => {
        const kngnStatus = res.data.result.status
        // ログインセッションを確認できなければログイン画面に遷移する
        if (!(status && result && kngnStatus)) {
          alert(MsgList.MSG_SES_CANNOT_CONFIRM)
          this.$router.push('/')
          this.$store.dispatch('appSetting/fLogin')
        } else {
          this.$store.dispatch('appSetting/tLogin')
          // 入力フォームに表示するセレクトボックスの選択肢を取得
          myAxios.get('api/evnt_mstr/event_master_shinki_touroku').then(res => {
            this.evnt_typList = res.data.typ_list
            this.bnri_typList = res.data.bnri_list
            this.kkiList = res.data.kikai_list
            // 空欄を削除
            for (var i = 0; i < this.evnt_typList.length; i++) {
              this.evnt_typList[i].no = this.evnt_typList[i].no.trim()
            }
            for (var t = 0; t < this.bnri_typList.length; t++) {
              this.bnri_typList[t].no = this.bnri_typList[t].no.trim()
            }
          })
        }
      })
    })
  },
  methods: {
    validate () {
      this.loading = true
      this.checkForm()
    },
    // 機械入力チェック
    checkKki () {
      if (!this.formData.kki_cd) {
        this.kkiCdIsValid = false
        this.blankIsValid = false
      } else {
        this.kkiCdIsValid = true
      }
    },
    // イベント名入力チェック
    checkName () {
      // ブランクチェック
      if (!this.formData.evnt_nm) {
        this.evntNameIsValid = false
        this.blankIsValid = false
      // 空文字チェック
      } else if (this.formData.evnt_nm.search('　') === 0) {
        this.evntNameIsValid = false
      } else if (this.formData.evnt_nm.search(' ') === 0) {
        this.evntNameIsValid = false
      // 文字数100チェック
      } else if (this.formData.evnt_nm.length > 100) {
        this.evntNameIsValid = false
      // 全て範囲内ならtrue
      } else {
        this.evntNameIsValid = true
      }
    },
    // イベントコード入力チェック
    checkCode () {
      // ブランクチェック
      if (!this.formData.evnt_cd) {
        this.evntCdIsValid = false
        this.blankIsValid = false
      // 空文字チェック
      } else if (this.formData.evnt_cd.indexOf(' ') > 0) {
        this.evntCdIsValid = false
      } else if (this.formData.evnt_cd.indexOf('　') > 0) {
        this.evntCdIsValid = false
      // 文字数10チェック
      } else if (this.formData.evnt_cd.length > 10) {
        this.evntCdIsValid = false
      // 記号を含むかチェック
      } else if (!(this.formData.evnt_cd).match(/^[A-Za-z0-9!@$#_.]*$/)) {
        this.evntCdIsValid = false
      // 既に使われているevent_cdかチェック
      } else if (!(this.evntDupCdIsValid)) {
        this.errorCdMsg = '既に使われているイベントコードです。別のイベントコードを入力してください。'
        this.evntCdIsValid = false
      // 全て範囲内ならtrue
      } else {
        this.evntCdIsValid = true
        this.errorCdMsg = ''
      }
    },
    // エラーメッセージを作成する
    makeErrorMsg () {
      this.errorMsg = ''
      // blankエラー
      if (!this.blankIsValid) {
        this.errorMsg = MsgList.MSG_FORM_INVALID
      }
      // 入力間違いエラー
      this.errorMsg = this.errorMsg + '\n' + this.errorMissMsg

      // イベントコードエラー
      if (!this.evntDupCdIsValid) {
        this.errorMsg = this.errorMsg + '\n' + this.errorCdMsg
      }
      this.blankIsValid = true
      this.errorCdMsg = ''
    },
    // 確認画面遷移前チェックを行う
    checkForm () {
      // formDataに格納
      // this.kkiSelectList = this.formData.kki_cd
      // this.bnri_typSelectList = this.formData.bnri_typ
      // this.event_typSelectList = this.formData.event_typ

      // // 何も入力されていなければ空欄にする
      // if (this.formData.kki_cd === null) {
      //   this.kkiSelectList = { kki_cd: '', kki_nm: '' }
      // }
      // if (this.formData.bnri_typ === '' || this.formData.bnri_typ === undefined) {
      //   this.formData.bnri_typ = ''
      //   this.bnri_typSelectList = { name: '', no: '' }
      // }
      // if (this.formData.event_typ === '' || this.formData.event_typ === undefined) {
      //   this.formData.event_typ = ''
      //   this.event_typSelectList = { name: '', no: '' }
      // }
      // 機械コード
      let k = this.kkiList.findIndex(v => v.kki_cd === this.select_kki_cd)
      // indexが不正の場合は初期値
      if (k === -1) {
        this.kkiSelectList = { kki_cd: '', kki_nm: '' }
      } else {
        this.kkiSelectList = this.kkiList[k]
      }
      // 分類
      let b = this.bnri_typList.findIndex(v => v.no === this.select_bnri_typ)
      // indexが不正の場合は初期値
      if (b === -1) {
        this.bnri_typSelectList = { name: '', no: '' }
      } else {
        this.bnri_typSelectList = this.bnri_typList[b]
      }
      // イベント区分
      console.log(this.select_evnt_typ)
      let e = this.evnt_typList.findIndex(v => v.no === this.select_evnt_typ)
      console.log(e)
      // indexが不正の場合は初期値
      if (e === -1) {
        this.event_typSelectList = { name: '', no: '' }
      } else {
        this.event_typSelectList = this.evnt_typList[e]
      }
      console.log(this.event_typSelectList)

      // 各フォームを再チェック
      const checkAll = async () => {
        let res = await myAxios.get('api/evnt_mstr/event_master_shinki_cd', {event_cd: this.formData.evnt_cd, kki_cd: this.formData.kki_cd.kki_cd})
        this.evntDupCdIsValid = res.data
        this.checkName()
        this.checkCode()
        this.checkKki()
        this.$refs.form.validate()
        // チェック項目が全て true ならば確認画面に遷移する false があればアラートを表示する
        if (this.evntDupCdIsValid && this.evntNameIsValid && this.evntCdIsValid && this.kkiCdIsValid) {
          this.isChange = false
          this.errorFlg = false
        } else {
          this.errorFlg = true
          this.makeErrorMsg()
        }
        this.loading = false
      }
      checkAll()
    },
    // 入力データをサーバーに送信・登録処理を行う
    submit () {
      this.checkDialog = false
      // kki_cdだけになるように変更
      this.formData.kki_cd = this.select_kki_cd
      // nameの要素を無くす、何も入力されていなければ空欄にする
      if (this.formData.bnri_typ === undefined || this.formData.bnri_typ === '') {
        this.formData.bnri_typ = ''
      } else {
        this.formData.bnri_typ = this.select_bnri_typ
      }
      if (this.formData.event_typ === undefined || this.formData.event_typ === '') {
        this.formData.event_typ = ''
      } else {
        this.formData.event_typ = this.select_evnt_typ
      }

      myAxios.post('/api/evnt_mstr/event_master_shinki_touroku_kakunin', this.formData).then(res => {
        const status = res.data.status
        const result = res.data.result

        if (status && result) {
          this.$router.push('/EvntMstr/EvntMstrKnr')
        } else {
          alert(MsgList.MSG_FORM_SUBMIT_ERROR)
        }
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        alert(MsgList.MSG_FORM_SUBMIT_ERROR)
      })
    },
    // 機械名を選択
    selectkki (event) {
      this.select_kki_cd = event.kki_cd
    },
    // 分類を選択
    selectbnri (event) {
      this.select_bnri_typ = event.no
    },
    // イベント区分を選択
    selectevnt (event) {
      this.select_evnt_typ = event.no
    }
  },
  computed: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/templates/EvntMstr/EvntMstrSnkTurk.vue